import { graphql } from 'gatsby';
import { VideoLayout } from '../../components/entities/video-layout';
import { createGatsbyPageComponent } from '@shapeable/ui';

export default createGatsbyPageComponent('Video', { layout: VideoLayout, debug: false });

export const QUERY = graphql`
  query videoQuery($id: ID!) {
    platform {
      video(id: $id) {
        id path slug name url published __typename _schema { label pluralLabel }
        description { id text }
        openGraph { description { id text } image { id url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
        types { id name slug __typename }
        type { id name slug __typename }
        embeds {
          imageAssets {
            id slug name image { id url url2x }
          }
          citations {
            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
          }
        }
        regions {
          __typename id name path slug typeLabel
          openGraph { id title description { id text } image { id url url2x } }
        }
        traditionalLands {
          __typename id name path slug typeLabel
          openGraph { id title description { id text } image { id url url2x } }
        }
        feedEntries { 
          id name path url slug __typename 
          published
          type { id name slug }
          openGraph { image { url url2x thumbnails { card { url url2x } bubble { url url2x } bubbleLarge { url url2x } } } }
        }
        posts { 
          id name path slug __typename 
          type { id slug name }
          published
          openGraph { image { url url2x thumbnails { card { url url2x } bubble { url url2x } bubbleLarge { url url2x } } } }
        }
        authors {
          id name slug path __typename
          organisation { id name }
          linkedin
          photo { id url url2x type }
        }
        people {
          id name slug path __typename
          organisation { id name }
          linkedin
          position
          photo { id url url2x type }
        }
      }
    }
  }`;
